<template>
  <b-container>
    <b-row class="text-center">
      <b-col>
        <div class="logo">
          <h2>{{ errors[errorKey].title }}</h2>
        </div>
        <br>

        <p
          v-if="errorText"
          class="lead">
          {{ errorText }}
        </p>
        <p
          v-else
          class="lead">
          {{ errors[errorKey].body }}
        </p>

        <p
          v-if="errors[errorKey].link"
          class="lead text-muted">
          <router-link :to="errors[errorKey].link">
            {{ errors[errorKey].linkText }}
          </router-link>
        </p>

        <p
          v-if="errors[errorKey].contactPrompt"
          class="lead text-muted">
          {{ errors[errorKey].contactPrompt }}
          <br>
          <b-link :href="'mailto://' + errors[errorKey].contactAddress">
            {{ errors[errorKey].contactAddress }}
          </b-link>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'Error',
    data() {
      return {
        errorKey: this.$route.query.type || 'unknown',
        errorText: this.$route.query.errorText,
        errors: {
          403: {
            title: '403',
            body: 'Oops, an error has occurred. Forbidden.',
            link: '/',
            linkText: 'Return Home',
            contactPrompt: 'If the problem persists, reach out to:',
            contactAddress: 'mobiletools-dev@mlb.com',
          },
          account: {
            title: 'Welcome to MLB App Tools',
            body: 'You have no Tools currently assigned to your account.',
            contactPrompt: 'For help, contact:',
            contactAddress: 'mobiletools-dev@mlb.com',
          },
          unknown: {
            title: 'Error',
            body: 'Oops, an error has occurred.',
            link: '/',
            linkText: 'Return Home',
            contactPrompt: 'If the problem persists, reach out to:',
            contactAddress: 'mobiletools-dev@mlb.com',
          },
        },
      }
    },
  }
</script>
